export type AgendaItemClosedReason =
  | "Open"
  | "SpeakerRegistrationDisabled"
  | "SpeakerListFull"
  | "StatusClosed";

export interface ClosedAgendaItemPresentation {
  badgeText: string;
  accessibleName: string;
  note: string;
}

const NOT_AVAILABLE: ClosedAgendaItemPresentation = {
  badgeText: "Signup unavailable",
  accessibleName: "Signup unavailable",
  note: "Speaker signup is not available for this item."
};

const SPEAKER_LIST_FULL: ClosedAgendaItemPresentation = {
  badgeText: "Speaker list full",
  accessibleName: "Speaker list full",
  note: "This item has reached its speaker limit. You can still attend and listen."
};

const SIGNUP_ENDED: ClosedAgendaItemPresentation = {
  badgeText: "Signup closed",
  accessibleName: "Signup closed",
  note: "Speaker signup for this item has ended. You can still attend and listen."
};

export function closedAgendaItemPresentation(
  reason: AgendaItemClosedReason | null | undefined
): ClosedAgendaItemPresentation | null {
  switch (reason) {
    case "Open":
      return null;
    case "SpeakerRegistrationDisabled":
      return NOT_AVAILABLE;
    case "SpeakerListFull":
      return SPEAKER_LIST_FULL;
    case "StatusClosed":
      return SIGNUP_ENDED;
    default:
      return null;
  }
}

export function resolveClosedReason(item: {
  closedReason?: AgendaItemClosedReason | null;
  acceptingSpeakers?: boolean;
  full?: boolean;
}): AgendaItemClosedReason {
  if (item.closedReason) return item.closedReason;

  if (item.acceptingSpeakers !== false) return "Open";

  return item.full === true ? "SpeakerListFull" : "StatusClosed";
}
